import { GetCustomerVendorsInput, UpdateCustomerVendor } from "shared";
import { axiosClient } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getQueryDataObject,
} from "utilz/helpers";

//get customer vendors
export const getCustomerVendors = async ({
  perPageCount,
  pageNumber,
  sortColumn = "",
  sortDirection = "asc",
  filter = [],
  searchQuery = "",
  customerId,
}: GetCustomerVendorsInput) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      // baseUrl: `/fetch/vendors/${customerId}`,
      baseUrl: `/v2/customers/${customerId}/vendors`,
      data,
    });
    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//add customer vendor
export const addCustomerVendor = async ({
  customerIdParams,
  data,
}: {
  customerIdParams: any;
  data: any;
}) => {
  try {
    // const url = `/create/vendor/${customerIdParams}`;
    const url = `/v2/customers/${customerIdParams}/vendors`;
    const response = await axiosClient.post(url, data);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

//update customer vendor
export const updateCustomerVendor = async ({
  vendorId,
  customerId,
  data,
}: UpdateCustomerVendor) => {
  try {
    const url = await generateUrlString({
      baseUrl: `/v2/vendors/${vendorId}`,
      data: {
        customer_id: customerId,
      },
    });
    const response = await axiosClient.patch(url, data);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteCustomerVendors = async ({
  customerIdParams,
  vendorIds,
}: {
  customerIdParams: any;
  vendorIds: any;
}) => {
  try {
    // const url = `/deactivate/vendor/${customerIdParams}`;
    const url = `/v2/customers/${customerIdParams}/vendors/status`;
    const response = await axiosClient.patch(url, vendorIds);
    const responseData = response.data;
    if (responseData.success && responseData.statusCode === 200) {
      return responseData.data;
    } else {
      throw response;
    }
  } catch (error: any) {
    console.log(error);
    apiErrorHandler(error);
  }
};
